// A marca pode variar por ambiente, mas continua funcional quando a variável não é informada.
export const PROJECT_NAME = process.env.REACT_APP_PROJECT_NAME?.trim() || 'Colmeia Barber';

// O que o produto entrega, em uma linha. Compõe o título da aba e as prévias de link.
export const PROJECT_TAGLINE = process.env.REACT_APP_PROJECT_TAGLINE?.trim()
    || 'Gestão completa para barbearias e salões';

// Título da aba no painel administrativo. As telas públicas sobrescrevem com o nome da empresa.
export const PROJECT_DOCUMENT_TITLE = `${PROJECT_NAME} | ${PROJECT_TAGLINE}`;

// Titular da plataforma. Fixo de propósito, e não derivado de PROJECT_NAME: aquele muda por
// ambiente (white label) e a titularidade da marca, não.
export const PLATFORM_BRAND = 'Colmeia Barber';

// Site institucional, onde ficam os planos, os Termos de uso e a Política de privacidade.
export const PLATFORM_SITE_URL = process.env.REACT_APP_SITE_URL?.trim() || 'https://colmeiabarber.com';

// Assinatura de marca exibida no rodapé das telas públicas.
export const PLATFORM_TRADEMARK = PLATFORM_BRAND;
export const PLATFORM_TRADEMARK_NOTICE = 'Todos os direitos reservados.';
